var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--medical-icon",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.119 34.179c4.725 0 6.916 3.587 7.378 8.679c.109 1.219-.005 2.995-.161 5.053c-.531 6.836-1.142 15.236 3.41 15.236c3.849 0 5.827-7.386 6.968-15.804c1.102-8.334-.065-12.481.508-16.181c1.094-7.011 7.215-13.297 5.324-22.237c-1.047-4.959-3.777-7.292-6.483-8.272c-6.231-2.268-10.255 2.102-16.946 2.102c-6.691 0-10.714-4.37-16.948-2.102c-2.703.98-5.433 3.313-6.482 8.272c-1.889 8.939 4.229 15.226 5.326 22.237c.573 3.7-.593 7.847.509 16.181c1.141 8.419 3.119 15.804 6.968 15.804c4.549 0 3.942-8.4 3.41-15.236c-.156-2.057-.271-3.834-.162-5.053c.46-5.092 2.682-8.679 7.379-8.679z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDental);
export default __webpack_public_path__ + "static/media/dental.e4b953ff1ea36aaac9095c0aa163dfbe.svg";
export { ForwardRef as ReactComponent };